import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Card, Dropdown, Loader} from 'semantic-ui-react';
import {partAuditDateFormat} from '../../common/constants/datesFormat';
import {getNumericValue} from '../../common/util/fieldsValidation';
import {pageSizes} from '../../common/constants/lists';
import {Actions} from '../../common/actions';
import TablePaginator from '../../common/components/tablePaginator';

class PartAuditListTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageSizeClick(event, data) {
    this.props.changeListPageSize(data.value);
  }

  onPageClick(value) {
    this.props.changeListPage(value);
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderPartAudit() {
    const {setPartAuditList} = this.props;

    if (!setPartAuditList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return setPartAuditList.map((element, index) => {
      const dateshow = moment(element.dmlDate).format(partAuditDateFormat);
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dmlUser}</Table.Cell>
          <Table.Cell textAlign='center'>{dateshow}</Table.Cell>
          <Table.Cell textAlign='center'>{element.dmlType}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {getNumericValue(element.mad, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.icc}</Table.Cell>
          <Table.Cell textAlign='center'>{element.pnc}</Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}{getNumericValue(element.customer_price, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}{getNumericValue(element.dealer_price, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}{getNumericValue(element.fob, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}{getNumericValue(element.cosdol, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.product}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrPartAudit() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' content='Cargando' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderPartAudit();
  }

  renderTableHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center'>
            Usuario Modificación{' '}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Fecha Modificación
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Código Parte</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>MAD</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>ICC</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>PNC</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Precio Público</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Precio Concesionario
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>FOB</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Costo</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Product</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped className='toyota-grid'>
          {this.renderTableHeader()}
          <Table.Body>{this.renderLoaderOrPartAudit()}</Table.Body>
          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'totalItems': state.partAudit.list.length,
    'pageNumber': state.partAudit.pageNumber,
    'pageSize': state.partAudit.pageSize,
    'setPartAuditList': state.partAudit.filteredList,
    'loading': state.partAudit.loading,
  };
};

const {
  changeListPage,
  changeListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeListPage,
  changeListPageSize,
})(PartAuditListTable);
